import * as Yup from 'yup';

const PHONE_NUMBER_LENGTH_BY_COUNTRY_CODE = {
  '+55': 11,
  '+54': 10,
  '+90': 10,
  '+595': 10,
};

export const getValidationSchemas = (
  t: (key: string, options?: any) => string,
  phoneCode: string
): Record<string, Yup.AnySchema> => {
  return {
    email: Yup.string().trim().required(t('requiredField')).email(t('pleaseEnterValidEmailAdress')),

    phoneNumber: Yup.string()
      .required(t('requiredField'))
      .matches(/^[0-9+]*$/, t('phoneNumberError'))
      .length(
        PHONE_NUMBER_LENGTH_BY_COUNTRY_CODE[phoneCode],
        t('phoneNumberLengthError', { length: PHONE_NUMBER_LENGTH_BY_COUNTRY_CODE[phoneCode] })
      ),

    address: Yup.string().matches(/^.*$/, t('fieldLength')),

    city: Yup.string()
      .nullable()
      .matches(/^.{2,24}$/, t('fieldLength', { count: '2-24' })),
  };
};
